import React from "react";
import AdminNavbar from "./AdminNavbar";
import { AdminNavbarAppearanceProvider } from "./AdminNavbarAppearanceContext";
import { theme1NavbarAppearance } from "./adminNavbarTheme1Appearance";

/** Mevcut (klasik) üst bar — Tema 1; tüm navbar stilleri appearance üzerinden */
const AdminNavbarTheme1 = (props) => (
  <AdminNavbarAppearanceProvider value={theme1NavbarAppearance}>
    <AdminNavbar {...props} />
  </AdminNavbarAppearanceProvider>
);

export default AdminNavbarTheme1;
